export function csvEscapeCell(value) {
  const s = value === undefined || value === null ? "" : String(value);
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function distributionPlotColumnTitle(distributionData, fallbackLabel) {
  const fromData = (distributionData?.xAxisTitle || "").trim();
  if (fromData) return fromData;
  return (fallbackLabel || "").trim();
}

export function csvSafeBaseName(label, fallback = "") {
  const raw = String(label ?? "").trim() || String(fallback ?? "").trim();
  if (!raw) return "";
  return raw
    .replace(/\u00b0/g, "")
    .replace(/[^a-z0-9]+/gi, "_")
    .replace(/^_+|_+$/g, "")
    .toLowerCase()
    .slice(0, 100);
}

export function buildQaqcDistributionFileName(distributionData, plotLabel, plotId) {
  const title = distributionPlotColumnTitle(distributionData, plotLabel);
  let slug = csvSafeBaseName(title);
  if (!slug) slug = csvSafeBaseName(plotId);
  if (!slug) slug = "plot";
  return `qaqc_distribution_${slug}.csv`;
}

/**
 * @param {string} prefix - e.g. "dl_material_balance_distribution" or "dl_overall_feed_deviation.csv"
 */
export function buildPrefixedDistributionFileName(prefix, distributionData, plotLabel, plotId) {
  let base = String(prefix || "distribution_chart").trim().replace(/\.csv$/i, "");
  base = base.replace(/[^a-zA-Z0-9_-]+/g, "_").replace(/^_+|_+$/g, "").toLowerCase();
  if (!base) base = "distribution_chart";
  const title = distributionPlotColumnTitle(distributionData, plotLabel);
  let slug = csvSafeBaseName(title);
  if (!slug) slug = csvSafeBaseName(plotId);
  if (slug) return `${base}_${slug}.csv`;
  return `${base}.csv`;
}

/**
 * @param {Array<{ sampleId?: string, asset?: string, field?: string, well?: string, reservoir?: string, fluidSampleID?: string, plotCategory?: string }>} rows
 * @param {string} plotColumnHeader - last column header (same as chart / x-axis title)
 */
export function buildDistributionSamplesCsvContent(rows, plotColumnHeader) {
  const plotHdr = String(plotColumnHeader || "").trim() || "Plot";
  const headers = ["Sample ID", "Asset", "Field", "Well", "Reservoir", "Fluid Sample ID", plotHdr];
  const lines = [
    headers.map(csvEscapeCell).join(","),
    ...rows.map((r) =>
      [
        r.sampleId ?? "",
        r.asset ?? "",
        r.field ?? "",
        r.well ?? "",
        r.reservoir ?? "",
        r.fluidSampleID ?? "",
        r.plotCategory ?? "",
      ]
        .map(csvEscapeCell)
        .join(",")
    ),
  ];
  return lines.join("\n");
}
